export const christmasImage = '/christmas-plaza.jpg';

export const christmasVideos = [
  { id: 'h8kpFM5PUhg', title: 'Jingle Bells', tag: { es: 'Plaza comercial', en: 'Shopping mall' } },
  { id: 'Mo1-yxhkTMY', title: 'Winter Wonderland', tag: { es: 'Plaza comercial', en: 'Shopping mall' } },
  { id: 'ks5AsvYnJ_0', title: 'This Christmas', tag: { es: 'En vivo', en: 'Live' } },
  { id: 'vru2iww5A3w', title: 'Christmas Medley', tag: { es: 'En vivo', en: 'Live' } },
];

export const christmasContent = {
  es: {
    eyebrow: 'Temporada Navideña',
    title: 'Navidad con Big Band',
    subtitle: 'El sonido clásico de las fiestas, en vivo. Llevamos la magia de una big band de jazz a plazas comerciales, posadas, cenas y celebraciones navideñas de todo tipo.',
    cta: 'Reservar fecha navideña',
    ctaVideos: 'Ver videos',
    seeMore: 'Ver página navideña',
    homeTitle: 'Reserva tu Navidad con Big Band',
    homeText: 'Noviembre y diciembre son nuestra temporada más solicitada. Llenamos plazas comerciales, posadas de empresa, cenas y encendidos de árbol con los clásicos navideños en formato big band. Las fechas se agotan rápido.',
    homePoints: ['Plazas y centros comerciales', 'Posadas y fiestas de empresa', 'Cenas privadas y hoteles', 'Encendido de árbol y eventos públicos'],
    eventsTitle: 'Eventos navideños',
    eventsSubtitle: 'Un formato para cada celebración de la temporada.',
    events: [
      { icon: 'ShoppingBag', title: 'Plazas y centros comerciales', desc: 'Conciertos navideños que atraen visitantes, generan ambiente festivo y aumentan la permanencia en tu plaza. Formatos de 1 o 2 horas, ideales junto al árbol principal.' },
      { icon: 'Briefcase', title: 'Posadas y fiestas de empresa', desc: 'Celebra el cierre del año con tu equipo: clásicos navideños, swing y repertorio bailable para que nadie se quede sentado.' },
      { icon: 'Wine', title: 'Cenas privadas y hoteles', desc: 'Ambientación elegante para cenas de Nochebuena, brunch navideño y eventos en salones y lobbies de hotel.' },
      { icon: 'TreePine', title: 'Encendido de árbol y eventos públicos', desc: 'El momento estelar de la temporada: acompañamos encendidos, desfiles y festivales con el brillo de una big band completa.' },
    ],
    repTitle: 'Repertorio navideño',
    repertoire: ['Jingle Bells', 'Winter Wonderland', 'This Christmas', 'Let It Snow', 'Have Yourself a Merry Little Christmas', 'Santa Claus Is Coming to Town', 'White Christmas', 'Feliz Navidad', 'Sleigh Ride', 'The Christmas Song'],
    videosTitle: 'Navidad en vivo',
    videosSubtitle: 'Así suena LAJO en temporada navideña.',
    whyTitle: '¿Por qué una big band en Navidad?',
    why: [
      { k: '8–16', v: 'músicos + cantante, según tu espacio' },
      { k: '1–2 h', v: 'formatos de 1 o 2 horas de música en vivo' },
      { k: 'ES · EN', v: 'repertorio bilingüe para todo público' },
    ],
    closingTitle: 'Las fechas de diciembre vuelan',
    closingText: 'Aparta tu fecha navideña con anticipación. Cotizamos formatos a la medida para plazas, empresas y eventos privados.',
  },
  en: {
    eyebrow: 'Holiday Season',
    title: 'Christmas with a Big Band',
    subtitle: 'The classic sound of the holidays, live. We bring the magic of a jazz big band to shopping malls, company parties, dinners and Christmas celebrations of every kind.',
    cta: 'Book a holiday date',
    ctaVideos: 'Watch videos',
    seeMore: 'See Christmas page',
    homeTitle: 'Book Your Big Band Christmas',
    homeText: 'November and December are our busiest season. We fill shopping malls, company holiday parties, dinners and tree lightings with Christmas classics in big band style. Dates sell out fast.',
    homePoints: ['Shopping malls & plazas', 'Company holiday parties', 'Private dinners & hotels', 'Tree lightings & public events'],
    eventsTitle: 'Christmas events',
    eventsSubtitle: 'A format for every celebration of the season.',
    events: [
      { icon: 'ShoppingBag', title: 'Shopping malls & plazas', desc: 'Holiday concerts that draw visitors, create a festive atmosphere and keep shoppers around longer. 1 or 2 hour formats, perfect beside the main tree.' },
      { icon: 'Briefcase', title: 'Company holiday parties', desc: 'Close the year with your team: Christmas classics, swing and a danceable set so nobody stays seated.' },
      { icon: 'Wine', title: 'Private dinners & hotels', desc: 'Elegant live music for Christmas Eve dinners, holiday brunches and events in hotel ballrooms and lobbies.' },
      { icon: 'TreePine', title: 'Tree lightings & public events', desc: 'The highlight of the season: we accompany tree lightings, parades and festivals with the shine of a full big band.' },
    ],
    repTitle: 'Christmas repertoire',
    repertoire: ['Jingle Bells', 'Winter Wonderland', 'This Christmas', 'Let It Snow', 'Have Yourself a Merry Little Christmas', 'Santa Claus Is Coming to Town', 'White Christmas', 'Feliz Navidad', 'Sleigh Ride', 'The Christmas Song'],
    videosTitle: 'Christmas live',
    videosSubtitle: 'This is how LAJO sounds during the holidays.',
    whyTitle: 'Why a big band for Christmas?',
    why: [
      { k: '8–16', v: 'musicians + vocalist, sized to your venue' },
      { k: '1–2 h', v: '1 or 2 hour live music formats' },
      { k: 'ES · EN', v: 'bilingual repertoire for every audience' },
    ],
    closingTitle: 'December dates go fast',
    closingText: 'Reserve your holiday date early. We quote custom formats for malls, companies and private events.',
  },
};
